export const getDeliveryTime = (
  productVariant: any,
  locale: string,
): { deliveryTime: number | string | null; isDeliveryTimeNumber: boolean } => {
  const currentDate = new Date();

  // Ensure we're getting a string or number, not an object
  let deliveryTimeStr: string | number | null = null;

  if (typeof productVariant?.attributes?.delivery_time === 'object') {
    // Get the localized delivery time if available
    deliveryTimeStr = productVariant?.attributes?.delivery_time?.[locale]?.value ?? null;
  } else if (
    typeof productVariant?.attributes?.delivery_time === 'string' ||
    typeof productVariant?.attributes?.delivery_time === 'number'
  ) {
    // If delivery_time is a direct string or number, use it
    deliveryTimeStr = productVariant.attributes.delivery_time;
  }

  if (!deliveryTimeStr) {
    return { deliveryTime: null, isDeliveryTimeNumber: false };
  }

  let deliveryTime: number | string | null = null;

  if (typeof deliveryTimeStr === 'string' && /^\d+-\d+$/.test(deliveryTimeStr)) {
    deliveryTime = deliveryTimeStr;
  } else if (!isNaN(Number(deliveryTimeStr))) {
    deliveryTime = Number(deliveryTimeStr);
  } else {
    const deliveryDate = new Date(deliveryTimeStr);
    if (!isNaN(deliveryDate.getTime())) {
      const timeDiff = deliveryDate.getTime() - currentDate.getTime();
      deliveryTime = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    } else {
      deliveryTime = deliveryTimeStr;
    }
  }

  return {
    deliveryTime,
    isDeliveryTimeNumber: typeof deliveryTime === 'number' && !isNaN(deliveryTime),
  };
};
